import { BaseKey, useShow } from '@refinedev/core';
import { Button, Tabs, FormProps } from "antd";
import TabPane from "antd/es/tabs/TabPane";
import { ChildForm, TableDB } from 'interfaces/schemaDB';
import React from 'react'
import Cw8Edit from './Cw8Edit';
import Cw8List from './Cw8List';
import { useSchemaDB } from '../../../src/hooks/useSchemaDB';

interface cw8EditWrapperProps{
    resourceLabel ?: string
    resourceName :string
    id : BaseKey | undefined 
    childrenForms : ChildForm[]
    modal ?:boolean
    editFormProps?: FormProps
}

interface BtnExtraProps{
    childrenForms : ChildForm[]
}

const BtnExtra = ({childrenForms} : BtnExtraProps) =>{
    return(
        <>{
            childrenForms.filter( btn => btn.url ).map( (btn, idx) =>
                <Button href={btn.url} target={"_blank"} style={{marginLeft:"10px"}}>{btn.title}</Button>
            )
        }
        </>
    )
}

const Cw8EditWrapper = ({resourceLabel, resourceName, id, childrenForms, modal, editFormProps} : cw8EditWrapperProps ) => {


    const { queryResult : queryResulthow } = useShow();
    const { data, isLoading } = queryResulthow;
    const record = data?.data;

    const {getTable} = useSchemaDB({nameTable:resourceName})
    const table = getTable(resourceName)
    // const childrenForms : ChildForm = table?(table.length>0?(table[0].childrenForms?table[0].childrenForms:[]):[]):[] 

    // const {schemaDBState } = useSchemaDB({nameTable : resourceName})

    // console.log(schemaDBState)
    // console.log(currentTable)

    let ID : any = id
    // if( config.provider == ProviderTypes.airTable ){

    //     let nameKey = ""
    //     if( currentTable ){
    //         nameKey = currentTable[0].fields.filter( field => field.isKey )[0].name
    //     }

    //     if(record){
    //         if( nameKey in record ){
    //             ID =  record[nameKey]
    //         }
    //     }        
    // }

    if(childrenForms.length == 0 || childrenForms.length>0){
        return(
            <Cw8Edit resourceName = {resourceName} 
                childrenForms={childrenForms} 
                idResource = {id}
                modal = {modal}
                editFormProps = {editFormProps}
            ></Cw8Edit>
        )
    }else{
        return(
            <>
            <Tabs defaultActiveKey="1" 
                tabBarExtraContent = {<BtnExtra childrenForms = {childrenForms}></BtnExtra>}
            >

                <TabPane tab={resourceLabel?resourceLabel:"General"} key="1">
                    <Cw8Edit resourceName = {resourceName}  
                        childrenForms={childrenForms}
                        idResource = {id}
                        modal = {modal}
                        editFormProps = {editFormProps}
                    ></Cw8Edit>
                </TabPane>

                {
                    childrenForms.filter( item => !item.url ).map( (child, index) =>(
                        <TabPane tab={child.title} key={index+2}>
                            <Cw8List
                                resourceName = {child.resourceName}
                                titleList = {child.title}
                                filterList ={[
                                    {
                                        // field: child.field,
                                        // operator: "eq",
                                        // value: id
                                        field: child.field,
                                        operator: "eq",
                                        value: ID
                                    }
                                ]}
                                showCards = {child.showCards?true:false}
                                configCard = {
                                    child.configCard?child.configCard:undefined
                                }
                            ></Cw8List>        
                        </TabPane>

                    ))
                }

            </Tabs>   
    
            </>            
        )
    }
        
}

export default Cw8EditWrapper
